import { render } from "./VesselForm.vue?vue&type=template&id=7778ab82"
import script from "./VesselForm.vue?vue&type=script&lang=js"
export * from "./VesselForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__